import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { ErrorResponse } from '../../../common/constants/globalConstants';

// RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
export const apiHandleError: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (action.payload) {
        const res = action.payload as ErrorResponse;
        if (
          res.data.errorCode === 503 &&
          window.location.pathname !== '/maintenance'
        ) {
          window.location.href = '/maintenance';
        }
      }
    }

    return next(action);
  };
